/* file: src/pages/BlogAdmin/BlogGenerator.js */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config/config';

import './BlogGenerator.css';

const BlogGenerator = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/blog-articles`);
      let articlesData = response.data;
      if (!Array.isArray(articlesData)) {
        if (typeof articlesData === 'string') {
          try {
            articlesData = JSON.parse(articlesData);
          } catch (e) {
            console.error('Fehler beim Parsen der Artikel:', e);
            articlesData = [];
          }
        } else if (articlesData && Array.isArray(articlesData.articles)) {
          articlesData = articlesData.articles;
        } else {
          articlesData = [];
        }
      }
      setArticles(articlesData);
    } catch (error) {
      console.error('Error fetching articles:', error);
      setArticles([]);
    }
  };

  return (
    <div className="blog-generator">
      <h2>Blog Generierung</h2>
      <div className="articles-container">
        {Array.isArray(articles) && articles.map(article => (
          <div key={article.id} className="article">
            <div className="original-article">
              <h3>{article.title}</h3>
              <p>{article.content}</p>
              <small>Quelle: {article.source} | {new Date(article.publishedAt).toLocaleString()}</small>
            </div>
            <div className="modified-article">
              <h3>Kontextualisierte Version</h3>
              <p>{`[Experten4Germany Kontext] ${article.content}`}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogGenerator;
